import React, {useEffect, useState} from "react";
import { ErrandAddressList, AlertModal } from '../../components';
import { utils } from "../../utils";
import { useNavigate, useLocation } from 'react-router-dom';
import { message } from "antd";

const ErrandAddressListScreen = ({logPage}) => 
{
	const navigate = useNavigate();
	const location = useLocation();
	
	const [os, setOs] = useState('');
	const [model, setModel] = useState('');
	const [alertModalTitle, setAlertModalTitle] = useState("");	
	const [alertModalBody, setAlertModalBody] = useState("");	
	const [alertModalOpen, setAlertModalOpen] = useState(false);	
	const [alertModalButton, setAlertModalButton] = useState("");
	const [alertModalButtonFunc, setAlertModalButtonFunc] = useState();
	const [alertModalButtonFunc2, setAlertModalButtonFunc2] = useState();
	
	useEffect(() => {		
		window.document.body.style.overflow = alertModalOpen ? "hidden" : "auto";
	}, [alertModalOpen]);
	
	useEffect(() => {
		const ref = document.referrer;
    const loc = location.pathname;
		logPage(ref, loc);
	}, []);
	
	useEffect(() => {
		setOs('');
		setModel('');
		document.title = `Errand Addresses | Order Online | ErrandLocal`;
		const checkLogin = async() => {
			const sessionemail = await utils.getStorage('__el_data_email');
			const redirect = await utils.checkLogin(sessionemail);
			if((redirect && sessionemail) || redirect){
				navigate(redirect);
			}
		}
		checkLogin();
	}, []);
	
	const execAddress = (app, title, description, addressId) => {
		
		app = title === 'null' && description === 'null' ? '' : app;
		title = title === 'null' ? 'Address' : title;
		description = description === 'null' ? '' : description;
		
		if(app){
			setAlertModalTitle(title ? title : 'Address');
			const b = description.split('|');
			let mainbody = '';
			for(let i=0; i<b.length; i++){
				mainbody += "<p style='font-size: 18px'>"+b[i]+"</p>";
			}
			setAlertModalBody(mainbody+"<br/><br/><div class='card-number' style='outline: none' key='d1'><div id='modal-status' style='display: none' key='d2'></div></div>");
			setAlertModalButton("1");
			setAlertModalButtonFunc('');
			setAlertModalButtonFunc2('editErrandAddress|'+addressId);
			setAlertModalOpen(!alertModalOpen);
		}else{
			setAlertModalTitle(title ? title : 'Address');
			const b = description.split('|');
			let mainbody = '';
			for(let i=0; i<b.length; i++){
				mainbody += "<p style='font-size: 18px'>"+b[i]+"</p>";
			}
			setAlertModalBody(mainbody+"<br/><br/><div class='card-number' style='outline: none' key='d1'><div id='modal-status' style='display: none' key='d2'></div></div>");
			setAlertModalButton("1");
			setAlertModalButtonFunc('');
			setAlertModalButtonFunc2('editErrandAddress|'+addressId);
			setAlertModalOpen(!alertModalOpen);
		}
	}
	
	const useAddress = async(action, thisaddress) => 
	{
		try
		{
			if(action === 'editErrandAddress'){
				navigate("/edit-address/errand/"+thisaddress);
				return false;
			};
			const email = await utils.getStorage('__el_data_email');
			const authToken = utils.getStorage('__el_data_login_token');
			const target = utils.USER_URL;
			const header = new Headers({
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': 'Bearer '+authToken,
			});
			const posturl = utils.BASE_URL+target; //utils.POST_URL;
			const localtime = await utils.getTime();
			const obj = JSON.stringify({'rtype': 'errandaddressswitch', 'email': email, 'addressId': thisaddress, 'os': os, 'model': model, 'localtime': localtime, 'target': target, 'token': authToken});
			const dataToPost = await utils.cipherEncode(obj);			
			const res = await utils.fetchURL(posturl, 'POST', dataToPost, header);
			const data = await res.json();
			
			if(data.msg === 'Success'){
				message.success('Address has been set to default');
				window.scrollTo({top: 0, behavior: 'smooth'});				
			}else{
				message.error(data.msg);
				window.scrollTo({top: 0, behavior: 'smooth'});
			}		
		}
		catch(e)
		{
			message.error(e.message);
		}	
	}
	
	const ExecAddressOperation = (type) => 
	{
		setAlertModalOpen(!alertModalOpen);
		const b = type.split('|');
		let action, target;		
		action = b[0];
		target = b[1];
		useAddress(action, target);
	}
	

	return (
		<>
			<ErrandAddressList execAddress={execAddress}/>
			{alertModalOpen && (<AlertModal setAlertOpenModal={setAlertModalOpen} alertModalTitle={alertModalTitle} alertModalBody={alertModalBody} alertModalButton={alertModalButton} setAlertModalButtonFunc={()=> ExecAddressOperation(alertModalButtonFunc)} setAlertModalButtonFunc2={()=> ExecAddressOperation(alertModalButtonFunc2)} alertType="address"/>)}
		</>
	)
};

export default ErrandAddressListScreen;
